<template>
  <div>
    <vxe-table row-id="id" :data="datalist" align="left">
      <vxe-table-column field="created_at" show-overflow min-width="100" title="时间"></vxe-table-column>
      <vxe-table-column field="service_name" show-overflow min-width="60" title="服务名称"></vxe-table-column>
      <vxe-table-column field="identifier" show-overflow min-width="60" title="标识符"></vxe-table-column>
      <vxe-table-column field="service_desc" show-overflow min-width="120" title="描述"></vxe-table-column>
      <vxe-table-column field="input_data" show-overflow min-width="240" title="输入参数"> </vxe-table-column>
      <vxe-table-column field="output_data" show-overflow min-width="240" title="输出参数"> </vxe-table-column>
    </vxe-table>
    <v-pagination v-if="total" @change-page="changePage" @change-size="changeSize" :total="total" name="page-basic" is-show-total is-change-size is-input-page :current-page="this.currentPage"></v-pagination>
  </div>
</template>

<script>
import { convertToYMDHMS } from '@/common/libs/utils';
export default {
  components: {},
  props: {
    devKey: {}
  },
  data() {
    return {
      datalist: [],
      currentPage: 1,
      pageSize: 10,
      total: 0
    };
  },
  created() {
    this.getData();
  },

  methods: {
    changePage(page) {
      this.currentPage = Number(page);
      this.getData();
    },
    changeSize(size) {
      this.pageSize = Number(size);
      this.currentPage = 1;
      this.getData();
    },
    async getData() {
      const subData = {
        dev_key: this.devKey,
        page_num: this.currentPage,
        page_size: this.pageSize
      };
      const res = await this.$post('/td/td-iot-api/iot/dev/services/v1', subData, false);
      if (res.code === 0) {
        this.total = res.data.page.total;
        this.datalist = res.data?.list.map(item => {
          try {
            item.input_data = JSON.stringify(
              Array.isArray(item.input_data)
                ? item.input_data.map(inputData => {
                    return { [inputData.identifier]: JSON.parse(inputData.data_value) };
                  })
                : item.input_data
            );
          } catch (e) {
            item.input_data = '数据格式不正确，解析失败';
          }
          try {
            item.created_at = convertToYMDHMS(item.created_at)
            item.output_data = item.output_data === null ? '-' : JSON.stringify(
              Array.isArray(item.output_data)
                ? item.output_data.map(outputData => {
                    return { [outputData.identifier]: JSON.parse(outputData.data_value) };
                  })
                : item.output_data
            );
          } catch (e) {
            item.output_data = '数据格式不正确，解析失败';
          }
          return item;

          
        });
      } else {
        if (res.code == '100410') {
          setTimeout(() => {
            this.getData();
          }, 1000);
        } else {
          this.$message.error(res.msg);
        }
      }
    }
  },
  beforeDestroy() {}
};
</script>

<style lang="scss"></style>
